export enum ProductType {
  Simple = 'Simple',
  Variation = 'Variation',
  Variable = 'Variable',
}

export enum ProductPublicationStatus {
  publish = 'publish',
  draft = 'draft',
  pending = 'pending',
  private = 'private',
}

export enum ProductStockStatus {
  instock = 'instock',
  outofstock = 'outofstock',
  onbackorder = 'onbackorder',
}
